import { render, staticRenderFns } from "./KufanghuikuByIdTable.vue?vue&type=template&id=50608031&"
import script from "./KufanghuikuByIdTable.vue?vue&type=script&lang=js&"
export * from "./KufanghuikuByIdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports